import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { getId } from 'office-ui-fabric-react/lib/Utilities';

import { parseFormattedNumberValue } from 'helpers/numberFormatting';

export default class NumericTextField extends Component {
  hostId = getId('tooltipHost');

  static defaultProps = {
    defaultValue: null,
    format: '0,0',
  };

  handleChange = (ev, value) => {};

  change = (e) => {
    const number = this.toNumber(e.target.value);
    const { onChanged } = this.props;
    this.field.setState({ value: number.formatted });
    if (onChanged) {
      onChanged(number.value);
    }
  };

  toNumber = (value) => {
    if (value === '' || value === null || typeof value === undefined)
      return {
        value: this.props.defaultValue,
        formatted:
          this.props.defaultValue !== null
            ? Intl.NumberFormat(this.props.locale).format(
                this.props.defaultValue
              )
            : '',
      };
    var number =
      typeof value === 'number'
        ? value
        : parseFormattedNumberValue(value, this.props.locale);
    return {
      value: number,
      formatted: Intl.NumberFormat(this.props.locale).format(number),
    };
  };

  onRenderLabel = () => {
    const { label, tooltip, required } = this.props;

    return (
      <label
        className="ms-Label"
        required={required || false}
        htmlFor={this.id}
        style={{
          paddingTop: '5px',
          paddingBottom: '5px',
          display: 'inline-block',
        }}
      >
        {label}
        {tooltip && (
          <Fragment>
            {' '}
            <TooltipHost
              content={tooltip}
              id={this.hostId}
              calloutProps={{ gapSpace: 0 }}
            >
              <Icon iconName="Info" />
            </TooltipHost>
          </Fragment>
        )}
      </label>
    );
  };

  render() {
    const { value, tooltip } = this.props;
    const number = this.toNumber(value);
    const onRenderLabel = tooltip ? this.onRenderLabel : undefined;
    const forwardedProps = _.omit(this.props, [
      'value',
      'defaultValue',
      'onRenderLabel',
      'onChanged',
      'onChange',
      'onBlur',
      'componentRef',
      'inputMode',
    ]);

    return (
      <TextField
        {...forwardedProps}
        onRenderLabel={onRenderLabel}
        value={number.formatted}
        onChange={this.handleChange}
        onBlur={this.change}
        componentRef={(t) => (this.field = t)}
        inputMode="decimal"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/NumericTextField/index.jsx